"use strict";
/**
 * Message types for LinkedIn Recruiter filter/scrape operations
 * Mirrors Sales Navigator messages but targets the Recruiter content script
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINKEDIN_REC_MESSAGE_TYPES = void 0;
exports.LINKEDIN_REC_MESSAGE_TYPES = {
    APPLY_FILTERS: "LINKEDIN_REC_APPLY_FILTERS",
    CLEAR_FILTERS: "LINKEDIN_REC_CLEAR_FILTERS",
    CHECK_STATUS: "LINKEDIN_REC_CHECK_STATUS",
    GET_RESULT_COUNT: "LINKEDIN_REC_GET_RESULT_COUNT",
    SCRAPE_ALL_ON_PAGE: "LINKEDIN_REC_SCRAPE_ALL_ON_PAGE",
    SCRAPE_ALL_ON_PAGE_SLOW: "LINKEDIN_REC_SCRAPE_ALL_ON_PAGE_SLOW",
    GO_TO_NEXT_PAGE: "LINKEDIN_REC_GO_TO_NEXT_PAGE",
    GO_TO_PREV_PAGE: "LINKEDIN_REC_GO_TO_PREV_PAGE",
    NAVIGATE_TO_PAGE: "LINKEDIN_REC_NAVIGATE_TO_PAGE",
    GET_PAGINATION_INFO: "LINKEDIN_REC_GET_PAGINATION_INFO",
    CLICK_SEARCH_BUTTON: "LINKEDIN_REC_CLICK_SEARCH_BUTTON",
    APPLY_OPEN_TO_WORK: "LINKEDIN_REC_APPLY_OPEN_TO_WORK",
    FETCH_AUTOCOMPLETE: "LINKEDIN_REC_FETCH_AUTOCOMPLETE",
};
